import { render, staticRenderFns } from "./DashboardUserAdm.vue?vue&type=template&id=7838c7a6&scoped=true&"
import script from "./DashboardUserAdm.vue?vue&type=script&lang=js&"
export * from "./DashboardUserAdm.vue?vue&type=script&lang=js&"
import style0 from "./DashboardUserAdm.vue?vue&type=style&index=0&id=7838c7a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7838c7a6",
  null
  
)

export default component.exports